import BaseTableController from './base_table_controller';

// dp_id 2010 — data_grid: { rows: [{ content_type, yes_no }] }
export default class extends BaseTableController {
  static values = { contentTypeOptions: Array, yesNoOptions: Array };

  searchableFields = ['content_type', 'yes_no'];

  connect() {
    const rows = this.initialDataValue?.rows;
    this.rows =
      Array.isArray(rows) && rows.length > 0
        ? rows.map((r) => ({
            content_type: r.content_type ?? '',
            yes_no: r.yes_no ?? '',
          }))
        : [this.emptyRow()];
    this.renderRows();
    this.syncHiddenField();
  }

  emptyRow() {
    return { content_type: '', yes_no: '' };
  }

  updateField(event) {
    const el = event.currentTarget;
    const index = parseInt(el.dataset.rowIndex, 10);
    this.rows[index][el.dataset.field] = el.value;
    this.syncHiddenField();
  }

  buildRow(row, index) {
    const tr = document.createElement('tr');
    tr.appendChild(
      this.buildSelectCell(row, index, 'content_type', this.contentTypeOptionsValue, {
        fullWidth: true,
      })
    );
    tr.appendChild(
      this.buildSelectCell(row, index, 'yes_no', this.yesNoOptionsValue, { fullWidth: true })
    );
    tr.appendChild(this.buildRemoveButton(index));
    return tr;
  }
}
